import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <TopicsSection />
        <IndexSection />
        <CarouselSection />
        <FaqSection />
        <UpdatesSection />
        <AboutSection />
        <AppSection />
        <FeaturesSection />
        <CommentsSection />
        <CardsSection />
        <MediaSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}